export default __webpack_public_path__ + "static/media/ic_attendance.8950a23f.svg";